/**
 * Plantillas para los diferentes tipos de recibos
 */

export interface EmpresaInfo {
  razonSocial: string;
  nit?: string;
  direccionCompleta: string;
  telefono1: string;
  telefono2?: string;
  email?: string;
  logoUrl?: string;
}

export interface ClienteInfo {
  nombre: string;
  dpi?: string;
  telefono?: string;
}

export interface DetalleVentaLote {
  tipoRecibo: 'venta_lote';
  numeroRecibo: string;
  fechaEmision: string;
  cliente: ClienteInfo;
  lotes: string; // Ej: "L-123, L-124"
  vendedor: string;
  fechaVenta: string;
  tipoPago: 'contado' | 'pagos';
  valorTotal: number;
  enganche?: number;
  numeroCuotas?: number;
  montoCuota?: number;
  boletaDeposito?: string;
  reciboCaja?: string;
}

export interface DetalleComision {
  tipoRecibo: 'pago_comision';
  numeroRecibo: string;
  fechaEmision: string;
  vendedor: ClienteInfo;
  lotes: string;
  comprador: string;
  fechaVentaOriginal: string;
  montoComision: number;
  fechaPago: string;
  transferencia: string;
  boleta: string;
}

export interface DetalleMovimiento {
  tipoRecibo: 'movimiento';
  numeroRecibo: string;
  fechaEmision: string;
  tipo: 'ingreso' | 'egreso';
  concepto: string;
  responsable: string;
  fecha: string;
  monto: number;
  referencia?: string;
  lotes?: string;
  vendedor?: string;
  comprador?: string;
}

export interface DetalleAbono {
  tipoRecibo: 'abono';
  numeroRecibo: string;
  fechaEmision: string;
  cliente: ClienteInfo;
  lotes: string;
  cuotaNumero?: number;
  fechaVencimiento?: string;
  montoAbono: number;
  fechaPago: string;
  transferencia: string;
  boleta: string;
  saldoPendiente?: number;
}

export interface DetalleDevolucion {
  tipoRecibo: 'devolucion';
  numeroRecibo: string;
  fechaEmision: string;
  cliente: ClienteInfo;
  lotes: string;
  vendedor: string;
  fechaSolicitud: string;
  motivo: string;
  montoPagado: number;
  penalizacion: number;
  porcentajePenalizacion: number;
  montoDevuelto: number;
  banco: string;
  beneficiario: string;
  boletaTransferencia: string;
}

export type DetalleRecibo = 
  | DetalleVentaLote 
  | DetalleComision 
  | DetalleMovimiento 
  | DetalleAbono 
  | DetalleDevolucion;

/**
 * Formatea un número a moneda guatemalteca
 */
export function formatCurrency(amount: number): string {
  return `Q${amount.toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/**
 * Formatea una fecha al formato guatemalteco (DD/MM/YYYY)
 */
export function formatDate(dateString: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Obtiene el título del recibo según el tipo
 */
export function getTituloRecibo(tipo: string): string {
  const titulos: Record<string, string> = {
    'venta_lote': 'RECIBO DE VENTA DE LOTE',
    'pago_comision': 'RECIBO DE PAGO DE COMISIÓN',
    'movimiento': 'RECIBO DE MOVIMIENTO',
    'abono': 'RECIBO DE ABONO A CUOTA',
    'devolucion': 'RECIBO DE DEVOLUCIÓN'
  };
  return titulos[tipo] || 'RECIBO';
}


